import { render, staticRenderFns } from "./hoaVillage.vue?vue&type=template&id=7306cece&scoped=true&"
import script from "./hoaVillage.vue?vue&type=script&lang=js&"
export * from "./hoaVillage.vue?vue&type=script&lang=js&"
import style0 from "./hoaVillage.vue?vue&type=style&index=0&id=7306cece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7306cece",
  null
  
)

export default component.exports